import { render, staticRenderFns } from "./NcpPasswordReset.vue?vue&type=template&id=6f73f73c"
import script from "./NcpPasswordReset.vue?vue&type=script&lang=js"
export * from "./NcpPasswordReset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports